import { MerchandiseMarketProduct } from '@epicuro-next/data/merchandise';
import { createAction, props } from '@ngrx/store';

export const loadMarketingProductsSuccess = createAction(
  '[Merchandise] Load Marketing Products Success',
  props<{ products: MerchandiseMarketProduct[] }>(),
);
